<template>
  <div class="root">
    <div class="bg">
      <picture>
        <source
          media="(min-width:1024px)"
          srcset="@/assets/fold1/desktop.jpg"
        />
        <img class="bgImg" src="@/assets/fold1/mobile.jpg" alt="bg fold1" />
      </picture>
    </div>
    <div class="header">
      <img alt="curnon logo" src="@/assets/logo-curnon.svg" height="40px" />
    </div>
    <div class="content">
      <!-- <div class="subtitle">Introduce</div> -->
      <div class="title">{{ `BLOOMING\nCOLLECTION` }}</div>
      <div class="preorder">
        <div class="discount">OFF 350K</div>
        <div class="discount-condition">KHI PRE-ORDER (đã hết hạn)</div>
      </div>
      <button class="cta-btn" v-scroll-to="'#products'">
        KHÁM PHÁ BỘ SƯU TẬP
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fold1",
};
</script>
<style lang="scss" scoped>
.root {
  min-height: 100vh;
  position: relative;
  .bg {
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .bgImg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  .header {
    padding-top: 14px;
    padding-bottom: 14px;
    text-align: center;
    z-index: 2;
  }
  .content {
    z-index: 2;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    color: #ffffff;
    text-align: center;
    padding: 16px;
    box-sizing: border-box;
    .title {
      font-size: 20px;
      line-height: 24px;
      font-family: "Rollgates Fabulous", sans-serif;
      font-style: italic;
      margin-bottom: 16px;
    }
    .subtitle {
      font-family: "SVN-Gotham", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 20px;
      /* identical to box height, or 100% */

      text-align: center;

      color: #ffffff;
      margin-bottom: 8px;
    }
    .cta-btn {
      background: #ffffff;
      font-family: "SVN-Gotham", sans-serif;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      padding: 24px 72px;
      border: none;
      margin-bottom: 60px;
      cursor: pointer;
    }
    .preorder {
      margin-bottom: 40px;
      .discount {
        font-family: "Rollgates Fabulous", sans-serif;
        font-style: italic;
        font-weight: normal;
        font-size: 48px;
        line-height: 54px;
        text-align: center;
        color: #ffffff;
      }
      .discount-condition {
        font-family: "SVN-Gotham", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 26px;
        /* identical to box height, or 186% */

        // color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}
@media (min-width: 1024px) {
  .root {
    .content {
      width: 50%;
      transform: translateX(50%);
      justify-content: center;
      .title {
        font-size: 24px;
        line-height: 24px;
        margin-bottom: 28px;
      }
      .subtitle {
        font-size: 20px;
        line-height: 20px;
      }
      .preorder {
        .discount {
          font-size: 64px;
          line-height: 64px;
        }
      }
      .cta-btn {
        // padding: 26px 72px;
      }
    }
  }
}
</style>
